import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export function useMediaData() {
    const getMediaData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}get-file${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postMediaData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}get-file${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}get-file${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putMediaData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}get-file${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchMediaData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}get-file${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteMediaData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}external-api-log${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getMediaData,
        postMediaData,
        putMediaData,
        patchMediaData,
        deleteMediaData
    };

};